<template>
    <div>
        <app-section-loader :status="form_loader"></app-section-loader>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-modal-print
                                ref="print"
                                @close-method="(file_name = null), $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <bc-scan-barcode
                                v-if="hasPerm('packing_lists.update')"
                                ref="scan_barcode"
                                scan-object="repack"
                                header-text="Scan Pack Label"
                                @scanned="setFromScan($event)"
                                @closed="scanned_repack = []"
                                @remove="removeFromSelected($event)"
                                @open="getRepacks(false)"
                                :show-default-slot="scanned_repack.length > 0"
                                scan-label="s"
                                :global="true"
                                :snackbar="false"
                            >
                                <template slot="button">
                                    <v-btn @mouseup.left="savePacks()" :disabled="scanned_repack.length == 0" color="success"> Add Packages </v-btn>
                                </template>
                                <template slot-scope="props" v-if="scanned_repack.length > 0">
                                    <vue-perfect-scrollbar
                                        :settings="settings"
                                        class="scroll-area"
                                        :style="$bp.xs ? null : $bp.smallScreen ? 'max-height: calc(100vh - 160px)' : 'max-height: calc(90vh - 160px)'"
                                    >
                                        <v-layout
                                            row
                                            v-for="(item, index) in scanned_repack"
                                            :key="`schedule-${index}`"
                                            class="schedule-list py-2"
                                            :class="{ 'grey lighten-3': index % 2 == 1 }"
                                        >
                                            <v-flex xs7 my-auto pl-0 pr-1>
                                                {{ item.batch_control_id }}
                                            </v-flex>
                                            <v-flex xs3 pl-0 pr-3 my-auto>
                                                <v-text-field
                                                    v-model="item.repack_qty"
                                                    :label="$t('lang.qty')"
                                                    hide-details
                                                    single-line
                                                    outline
                                                    readonly
                                                    class="center-label qty-full"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1 my-auto>
                                                <v-btn icon class="mx-0" @click="props.remove(index)">
                                                    <v-icon color="grey lighten-1" class="hover-red-icon">delete</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </vue-perfect-scrollbar>
                                </template>
                            </bc-scan-barcode>
                            <bc-btn-add @invoke-method="invokeMethod($event)" action="addPacks" permanent perm="packing_lists.update"></bc-btn-add>
                            <v-menu left content-class="no-stripe">
                                <template slot="activator">
                                    <v-btn icon>
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile @click="dev_mode ? showPrinter() : printLabel()">
                                        <v-list-tile-title> Print </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile
                                        @click="
                                            currObjField('has_bol') == '1'
                                                ? $router.push({ name: 'bill_of_lading', params: { id: currObjField('bol_id') } })
                                                : confirmBOL()
                                        "
                                    >
                                        <v-list-tile-title>
                                            {{ currObjField("has_bol") == "1" ? "View BOL" : "Create BOL" }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile
                                        v-if="hasPerm('invoices.read') && (currObjField('has_invoice') == '1' || hasPerm('invoices.create'))"
                                        @click="
                                            currObjField('has_invoice') == '1'
                                                ? $router.push({ name: 'invoice', params: { id: currObjField('invoice_id') } })
                                                : confirmInvoice()
                                        "
                                    >
                                        <v-list-tile-title>
                                            {{ currObjField("has_invoice") == "1" ? "View Invoice" : "Create Invoice" }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <template v-if="hasPerm('packing_lists.update')">
                                        <v-divider class="ml-3 my-0"></v-divider>
                                        <v-list-tile @click="updateShipped">
                                            <v-list-tile-title>
                                                {{ currObjField("shipped") == "1" ? "Mark as Pending" : "Mark as Shipped" }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </template>
                                    <template v-if="hasPerm('packing_lists.delete')">
                                        <v-divider class="ml-3 my-0"></v-divider>
                                        <v-list-tile @click="$refs.delete_packing_list.openDialog()">
                                            <v-list-tile-title> Delete </v-list-tile-title>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="$router.push({ name: 'packing_lists' })">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.back_to_list") }}
                            </bc-tooltip>
                            <!-- <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text>
                    <v-card elevation="10">
                        <v-card-text>
                            <div class="ribbon ribbon-top-right" :class="`ribbon-${currObjField('status_class')}`">
                                <span class="ribbon-span">{{ currObjField("status") }}</span>
                            </div>
                            <v-layout row wrap class="px-3 pt-3 pb-1 clickable hoverable rounded" @mouseup.left="getCustomer(currObjField('company_id'))">
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.company") }}</span>
                                    <h3>{{ currObjField("company") ? currObjField("company") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">Sold To</span>
                                    <h3 style="white-space: pre">{{ currObjField("sold_to_address_label") || "---" }}</h3>
                                    <h3 style="white-space: pre">{{ currObjField("sold_to_address") || "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">Ship To</span>
                                    <h3 style="white-space: pre">{{ currObjField("ship_to_address_label") || "---" }}</h3>
                                    <h3 style="white-space: pre">{{ currObjField("ship_to_address") || "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.carrier_id") }}</span>
                                    <h3>{{ currObjField("shipping_provider") ? currObjField("shipping_provider") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.salesman") }}</span>
                                    <h3>{{ currObjField("created_by") ? currObjField("created_by") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.payment_term") }}</span>
                                    <h3>{{ currObjField("payment_term_description") ? currObjField("payment_term_description") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.date_shipped") }}</span>
                                    <h3>{{ currObjField("date_shipped") ? currObjField("date_shipped") : "---" }}</h3>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap class="pa-0">
                                <v-flex xs12>
                                    <v-switch v-model="view_packs" :label="view_packs ? $t('lang.pack_view') : $t('lang.batch_view')" class="my-2"></v-switch>
                                    <v-data-table
                                        v-if="view_packs"
                                        :headers="pack_headers"
                                        :items="pack_view"
                                        :no-data-text="$t('lang.no_results_matching')"
                                        hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td>{{ props.item.shipping_unit }}</td>
                                                <td>{{ props.item.hazardous_material == "1" ? $t("lang.yes") : $t("lang.no") }}</td>
                                                <td>{{ props.item.customer_part_number }}</td>
                                                <td>{{ props.item.shipping_weight || "---" }}</td>
                                                <td>{{ props.item.repack_qty || "---" }}</td>
                                                <td class="text-center">
                                                    <v-btn icon class="mx-0" @click="deleteRepack(props.item)">
                                                        <v-icon color="grey lighten-1" class="hover-red-icon">delete</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <v-data-table
                                        v-else
                                        :headers="batch_headers"
                                        :items="batch_view"
                                        :no-data-text="$t('lang.no_results_matching')"
                                        hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td>{{ props.item.batch_control_id }}</td>
                                                <td>{{ props.item.batch_number || "---" }}</td>
                                                <td>{{ props.item.customer_part_number }}</td>
                                                <td>{{ props.item.lot_number || "---" }}</td>
                                                <td class="text-center">{{ props.item.total_processed }}</td>
                                                <td class="text-center">{{ props.item.qty }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
            <bc-dialog :value="packing_list_dialog" max-width="700">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.edit_packing_list") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close @invoke-method="packing_list_dialog = false" :dialog-status="packing_list_dialog"></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="packing_list">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            :value="currObjField('company')"
                                            :label="$t('lang.company')"
                                            append-icon="lock"
                                            readonly
                                            class="prevent-click"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-autocomplete
                                            v-model="packing_list.ship_to_address_id"
                                            :label="$t('lang.ship_to_address_id')"
                                            :items="shipping_addresses || []"
                                            item-value="entity_addresses_id"
                                            item-text="full_single_line_address"
                                            :no-data-text="$t('lang.none_set_add_from_company')"
                                            clearable
                                            @click:clear="
                                                $nextTick(() => {
                                                    packing_list.ship_to_address_id = '';
                                                })
                                            "
                                            :rules="ifValid('packing_list.ship_to_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-autocomplete
                                            v-model="packing_list.sold_to_address_id"
                                            :label="$t('lang.sold_to_address_id')"
                                            :items="billing_addresses || []"
                                            item-value="entity_addresses_id"
                                            item-text="full_single_line_address"
                                            :no-data-text="$t('lang.none_set_add_from_company')"
                                            clearable
                                            @click:clear="
                                                $nextTick(() => {
                                                    packing_list.sold_to_address_id = '';
                                                })
                                            "
                                            :rules="ifValid('packing_list.sold_to_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <bc-autocomplete
                                            v-model="packing_list.payment_term_id"
                                            :label="$t('lang.payment_term')"
                                            :items="payment_terms"
                                            item-value="payment_term_id"
                                            item-text="description"
                                            :rules="ifValid('packing_list.payment_term_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <bc-date-picker
                                            v-model="packing_list.date_shipped"
                                            :label="$t('lang.date_shipped')"
                                            :rules="ifValid('packing_list.date_shipped')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <bc-autocomplete
                                            v-model="packing_list.carrier_id"
                                            :label="$t('lang.carrier_id')"
                                            :items="shipping_carriers"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('packing_list.carrier_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="packing_list_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyPackingList('patch', currObjField('packing_list_id'))">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="select_packs_dialog" max-width="1000">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.select_packs") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="(select_packs_dialog = false), (selected_packs = [])"
                            :dialog-status="select_packs_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-data-table
                            v-model="selected_packs"
                            :headers="select_pack_headers"
                            :items="available_packs"
                            item-key="repack_id"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                            select-all
                        >
                            <template slot="items" slot-scope="props">
                                <tr :active="props.selected" @click.stop="props.selected = !props.selected" class="clickable">
                                    <td>
                                        <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                                    </td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.batch_control_id }}</td>
                                    <td>{{ props.item.customer_part_number }}</td>
                                    <td>{{ props.item.shipping_unit }}</td>
                                    <td>{{ props.item.repack_qty }}</td>
                                    <td>{{ props.item.created_by }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="(select_packs_dialog = false), (selected_packs = [])">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="savePacks()" :disabled="selected_packs.length == 0">{{ $t("lang.add") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="invoice_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.create_invoice") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="invoice_dialog"
                            :dialog-status="invoice_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22">Are you sure you want to create an invoice?</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="invoice_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="createInvoice()">
                            {{ $t("lang.create") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="bol_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.create_bol") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="bol_dialog" :dialog-status="bol_dialog"></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22">Are you sure you want to create a Bill of Lading?</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="bol_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="createBOL()">
                            {{ $t("lang.create") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_packing_list"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_packing_list')"
                :message="$t('lang.delete_packing_list_confirm')"
                @onConfirm="modifyPackingList('delete', currObjField('packing_list_id'))"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_packing_detail"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteRepack()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            select_pack_headers: [
                { text: this.$t("lang.part"), sortable: false },
                { text: this.$t("lang.batch_control_id"), sortable: false },
                { text: this.$t("lang.part_number"), sortable: false },
                { text: this.$t("lang.unit"), sortable: false },
                { text: this.$t("lang.qty"), sortable: false },
                { text: this.$t("lang.repack_by"), sortable: false },
            ],
            pack_headers: [
                { text: this.$t("lang.shipping_unit"), sortable: false },
                { text: this.$t("lang.hazardous_material"), sortable: false },
                { text: this.$t("lang.part_number"), sortable: false },
                { text: this.$t("lang.shipping_weight"), sortable: false },
                { text: this.$t("lang.qty"), sortable: false },
                { text: "", sortable: false },
            ],
            batch_headers: [
                { text: this.$t("lang.dta_control"), sortable: false },
                { text: this.$t("lang.batch_number"), sortable: false },
                { text: this.$t("lang.part_number"), sortable: false },
                { text: this.$t("lang.lot_number"), sortable: false },
                { text: this.$t("lang.processed_qty"), sortable: false, align: "center" },
                { text: this.$t("lang.shipped_qty"), sortable: false, align: "center" },
            ],
            packing_list: {
                company_id: "",
                sold_to_address_id: "",
                ship_to_address_id: "",
                date_shipped: "",
                carrier_id: "",
                payment_term_id: "",
            },
            current_obj: null,
            selected_detail: null,
            selected_packs: [],
            scanned_repack: [],
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            form_loader: false,
            packing_list_dialog: false,
            select_packs_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "addPacks" },
                { title: this.$t("lang.create_invoice"), action: "confirmInvoice" },
                { title: this.$t("lang.print"), action: "showPrinter" },
            ],
            batch_view: [],
            pack_view: [],
            customers: null,
            invoice_dialog: false,
            bol_dialog: false,
            billing_addresses: [],
            shipping_addresses: [],
            view_packs: true,
            available_packs: [],
            file_name: null,
            settings: {
                suppressScrollX: true,
            },
        };
    },
    beforeRouteEnter(to, from, next) {
        store
            .dispatch("fetchPackingList", {
                url: `packing_lists/${to.params.id}`,
                method: "get",
                stateProperty: "packing_list",
                commit: true,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.packing_list) {
                    next((vm) => {
                        vm.assignObj(vm.packing_list, data.packing_list);
                        vm.setViews();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        this.$store
            .dispatch("fetchPackingList", {
                url: `packing_lists/${to.params.id}`,
                method: "get",
                stateProperty: "packing_list",
                commit: true,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.packing_list) {
                    this.assignObj(this.packing_list, data.packing_list);
                    this.setViews();
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_packing_list: (state) => state.validation.rules_packing_list,
            profile: (state) => state.packing_lists.packing_list,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
        }),
        currObjField() {
            return (field) => {
                return this.profile && field && this.profile[field] ? this.profile[field] : "";
            };
        },
    },
    methods: {
        ...mapActions(["fetchPaymentTerms", "fetchCustomer", "fetchPeople", "fetchShippingCarriers"]),
        confirmInvoice() {
            this.invoice_dialog = true;
        },
        createInvoice() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchPackingList", {
                    url: `invoices`,
                    method: "post",
                    body: {
                        packing_list_id: this.$route.params.id,
                    },
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$router.push({ name: "invoice", params: { id: data.invoices.invoice_id } });
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        confirmBOL() {
            this.bol_dialog = true;
        },
        createBOL() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchBillOfLading", {
                    url: `bill_of_ladings`,
                    method: "post",
                    body: {
                        packing_list_id: this.$route.params.id,
                    },
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$router.push({ name: "bill_of_lading", params: { id: data.bill_of_lading.bol_id } });
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        modifyPackingList(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("packing_list")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchPackingList", {
                                url: `packing_lists/${id ? id : ""}`,
                                method: method,
                                stateProperty: "packing_list",
                                commit: method == "delete" ? false : true,
                                body: this.packing_list,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.packing_list_dialog = false;
                                    this.$store.commit("validationOff");
                                    if (method == "delete") {
                                        this.$router.push({ name: "packing_lists" });
                                    }
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        setViews() {
            if (this.currObjField("packing_list_details")) {
                this.pack_view = this.currObjField("packing_list_details");
                this.batch_view = _.map(this.currObjField("packing_list_details"), (e) => e.batch_details).flatten();
            } else {
                this.pack_view = [];
                this.batch_view = [];
            }
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "customers",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.customers;
                    }
                });
        },
        getShippingCarriers() {
            this.$store.dispatch("fetchShippingCarriers", {
                url: "shipping_carriers",
                method: "get",
                stateProperty: "shipping_carriers",
                commit: true,
                body: { options: 1, department_id: "2" },
            });
        },
        getCustomer(company_id = null) {
            this.packing_list_dialog = true;
            this.fetchCustomer({ id: company_id }).then((data) => {
                if (typeof data !== "undefined" && data.customer) {
                    this.current_customer = data.customer;
                    this.assignObj(this.packing_list, data.customer);
                    if (data.customer.entity_addresses) {
                        let grouped = _.groupBy(this.current_customer.entity_addresses, "address_type");
                        this.billing_addresses = grouped && grouped.billing ? grouped.billing : [];
                        if (this.billing_addresses.length > 0) this.packing_list.sold_to_address_id = this.billing_addresses[0].entity_addresses_id;

                        this.shipping_addresses = grouped && grouped.shipping ? grouped.shipping : [];
                        if (this.shipping_addresses.length > 0) this.packing_list.ship_to_address_id = this.shipping_addresses[0].entity_addresses_id;
                    } else {
                        this.billing_addresses = [];
                        this.shipping_addresses = [];
                    }
                    if (this.shipping_carriers.length == 0) this.fetchShippingCarriers({ body: { options: 1, department_id: "2" } });
                    if (this.payment_terms.length == 0) this.fetchPaymentTerms({ body: { options: 1 } });

                    this.$store.commit("validationOff");
                }
                this.$store.commit("toggleModalLoader", false);
            });
        },
        getRepacks(status = true) {
            if (status) this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchRepack", {
                    url: "repack/available",
                    method: "get",
                    body: {
                        company_id: this.currObjField("company_id"),
                    },
                })
                .then((data) => {
                    if (data && data.repack) {
                        this.available_packs = data.repack;
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        addPacks() {
            this.select_packs_dialog = true;
            this.getRepacks();
        },
        savePacks() {
            this.$store.commit("toggleModalLoader", true);
            let _packs = [];
            let packs_to_add = this.selected_packs.length > 0 ? this.selected_packs : this.scanned_repack;
            _packs.push(...packs_to_add.map((p) => p.repack_id));
            if (this.pack_view && this.pack_view.length > 0) _packs.push(...this.pack_view.map((p) => p.repack_id));
            this.$store
                .dispatch("fetchPackingList", {
                    url: `packing_lists/${this.$route.params.id}`,
                    method: "patch",
                    stateProperty: "packing_list",
                    commit: true,
                    body: {
                        packing_list_details: _packs,
                    },
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        // remove packs from available
                        packs_to_add.forEach((pack) => {
                            this.available_packs.splice(
                                this.available_packs.findIndex((obj) => obj.repack_id == pack.repack_id),
                                1
                            );
                        });

                        if (this.scanned_repack.length > 0) {
                            this.$refs.scan_barcode.closeBarcode(false);
                        }
                        this.select_packs_dialog = false;
                        this.scanned_repack = [];
                        this.selected_packs = [];
                        this.setViews();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        showPrinter() {
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchPackingList", {
                    url: `packing_lists/print_packing_list`,
                    method: "get",
                    body: {
                        packing_list_id: this.currObjField("packing_list_id"),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.packing_lists) {
                        this.file_name = data.packing_lists.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel() {
            this.$store.commit("toggleGlobalSnackbar", true);
            this.$store
                .dispatch("fetchPackingList", {
                    url: `packing_lists/print_packing_list`,
                    method: "get",
                    body: {
                        packing_list_id: this.currObjField("packing_list_id"),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.packing_lists) {
                        this.$refs.print.printReport(data.packing_lists.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
        updateShipped() {
            let shipped = this.currObjField("shipped") == "1" ? "0" : "1";
            let packing_list_id = this.currObjField("packing_list_id");
            this.$store.dispatch("fetchPackingList", {
                id: packing_list_id,
                pk: "packing_list_id",
                url: `packing_lists/${packing_list_id}`,
                method: "patch",
                stateProperty: "packing_list",
                commit: true,
                body: {
                    shipped: shipped,
                },
            });
        },
        deleteRepack(pack_detail) {
            this.selected_detail = pack_detail;
            this.$refs.delete_packing_detail.openDialog();
        },
        confirmDeleteRepack() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchPackingList", {
                    id: this.selected_detail.detail_id,
                    pk: "detail_id",
                    url: `packing_lists/${this.selected_detail.packing_list_id}/detail/${this.selected_detail.detail_id}`,
                    method: "delete",
                    stateProperty: "packing_list.packing_list_details",
                    mutate: true,
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$refs.delete_packing_detail.close();
                        this.setViews();
                        // add deleted pack back to available
                        this.selected_detail.batch_control_id = this.selected_detail.batch_details.map((b) => b.batch_control_id).join(", ");
                        this.available_packs.push(this.selected_detail);
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        removeFromSelected(index) {
            this.scanned_repack.splice(index, 1);
        },
        setFromScan(scan) {
            // console.log(this.schedule.filter(w=>w.receiving_id == scan.receiving_id)[0])
            let found_scan = null;
            if (scan && scan.repack_id) {
                found_scan = this.available_packs.filter((w) => w.repack_id == scan.repack_id)[0];
                if (found_scan && this.scanned_repack.filter((s) => s.repack_id == scan.repack_id).length == 0) {
                    this.scanned_repack.push(found_scan);
                    if (!this.$refs.scan_barcode.barcode_dialog) this.$refs.scan_barcode.barcode_dialog = true;
                } else {
                    found_scan = null;
                }
            }
            if (!found_scan) {
                this.createAlert("error", "scan_again");
            }
            this.$refs.scan_barcode.resetBarcode();
        },
    },
};
</script>
